import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractItemComponent } from '@df/catalog-ui/abstract-item.component';
import { IPageDataV2, IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { ImageModule } from '@df/module-image/image.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsPage } from '@icms/core/resource/page/icms-page';
import { LocalPage } from '../../../../page.decorator';
import { NBlogCategoryPageType } from '../../../page/category-view/cms-blog-page-category-view.component';
import { NBlogPostPageType } from '../../../page/post-view/cms-blog-post.namespace';

@Component({
    selector: 'cms-blog-component-more-stories-item',
    templateUrl: './cms-blog-component-more-stories-item.html',
    standalone: true,
    imports: [ImageModule, DatePipe, RouterLink, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsBlogComponentMoreStoriesItemComponent extends AbstractItemComponent<LocalPage<IPageDataV3<NBlogPostPageType.ITypeData>>> {
    type = ICmsPage.type;
    protected tagCategories: LocalPage<IPageDataV2<NBlogCategoryPageType.ITypeData>>[] = [];

    protected override onModelChange(): void {
        this.tagCategories =
            (this.model as LocalPage<IPageDataV3<NBlogPostPageType.ITypeData>>)?.getBlogPostCategories()?.slice(0, 3) || [];
        super.onModelChange();
    }

    get typeData() {
        return this.model?.data?.typeData;
    }
}
